import request from '../utils/request';

export default class SystemManagement {
    /**
     * 获取所有的站点信息
     * @param params
     * @returns {*|Promise<*>}
     */
    static addUser = (params) => {
        return request.post(`/ocp-saas/api/0/user/add`, params, {
          headers: {
            'DATA-NODE': ''
          }
        })
    }
    static updatePwd = (params) => {
        return request.post(`/ocp-saas/api/0/user/updatePwd`, params)
    }
    static updateUser = (params) => {
        return request.post(`/ocp-saas/api/0/user/update`, params)
    }
    static list = (params) => {
        return request.post(`/ocp-saas/api/0/user/list`, params)
    }
    static deleteUser = (params) => {
        return request.post(`/ocp-saas/api/0/user/delete`, params)
    }
    static listBusinessDepts = (params) => {
        return request.post(`/ocp-saas/api/0/dept/listBusinessDepts?manageDeptId=${params.id}`)
    }
}
